module.exports = __webpack_public_path__ + "img/frames.949e00f2.jpg";